import { Check } from "@mui/icons-material"
import { Button, Card, CardContent, Divider } from "@mui/material"
import moment from "moment"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import FormAutocomplete from "../../../../shared/FormAutocomplete"
import FormDate from "../../../../shared/FormDate"
import FormNumber from "../../../../shared/FormNumber"
import FormText from "../../../../shared/FormText"
import notificationError from "../../../../shared/notificationError"
import notificationSuccess from "../../../../shared/notificationSuccess"
import { editRemoveTarget } from "../removeTarget.api"

export default function RemoveTargetApprovalHead(props: any) {

    const dispatch = useDispatch()

    const [values, setValues] = useState<any>({
        id: "",
        name: "",
        value: "",
        notes: "",
        head_status_id: "",
        notes_approval: ""
    })

    useEffect(() => {
        setValues({
            id: props.data.id,
            name: moment(props.data.name).format("YYYY-MM-DD"),
            value: props.data.value,
            notes: props.data.notes,
            head_status_id: props.data.head_status_id,
            notes_approval: props.data.notes_approval
        })
    }, [])

    const handleChangeValues = (e: any) => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
        dispatch<any>(editRemoveTarget(values))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("success edit remove target")
                        .then(() => {
                            props.onClose(true)
                        })
                }
                else {
                    notificationError(response)
                }
            })
    }

    return (
        <Card>
            <CardContent className="custom-form">
                <form onSubmit={handleSubmit}>
                    <Divider />
                    <br />
                    <FormDate label="Remove Target Date" name="name" value={values.name} onChange={handleChangeValues} disabled />
                    <br />
                    <Divider />
                    <br />
                    <FormNumber label="Remove Target" name="value" value={values.value} onChange={handleChangeValues} disabled />
                    <br />
                    <Divider />
                    <br />
                    <FormText label="Notes" name="notes" value={values.notes} onChange={handleChangeValues} disabled />
                    <br />
                    <Divider />
                    <br />
                    {values.id && <FormAutocomplete url="/status/approval" label="Status" name="head_status_id" value={values.head_status_id} onChange={handleChangeValues} />}
                    <br />
                    <Divider />
                    <br />
                    <FormText label="Rejection Notes" name="notes_approval" value={values.notes_approval} onChange={handleChangeValues} />
                    <br />
                    <Divider />
                    <br />
                    <div className="form-footer">
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => props.onClose(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Check />}
                            type="submit"
                        >
                            Update Remove Target
                        </Button>
                    </div>
                </form>
            </CardContent>
        </Card >
    )
}